export function getObjectData(objectGetter, defaultValue = undefined) {
    try {
        return objectGetter();
    } catch (e) {
        return defaultValue;
    }
}
